<template>
  <div class="company">
    <Banner
      ref="cBanner"
      :banner_img="resBanners"
      banner_en="ABOUT US"
      banner_cn="关于我们"
    ></Banner>
    <div class="box_nav clear">
      <div class="pnav clear">
        <div
          :class="[item.key === componentTag.key ? 'on' : '', 'navItem']"
          v-for="item in pnavList"
          :key="item.key"
        >
          <router-link class="nuxtLink" :to="'/company?key=' + item.key" :key="item.key">
            {{ item.text }}
          </router-link>
        </div>
      </div>
      <div class="decoration1"></div>
    </div>
    <i class="companyLine"></i>
    <!-- 核心模块 -->
    <transition mode="out-in">
      <component :is="componentTag.key"></component>
    </transition>
  </div>
</template>
<script>
import Banner from "@/components/common/Banner.vue";
import CompanyProfile from "@/components/company/CompanyProfile.vue";
import Honor from "@/components/company/Honor.vue";
import DevelopmentPath from "@/components/company/DevelopmentPath.vue";
import CompanyCulture from "@/components/company/CompanyCulture.vue";
export default {
  data() {
    return {
      componentTag: {
        index: 0,
        text: "公司简介",
        key: "CompanyProfile",
      },
      pnavList: [
        {
          index: 0,
          text: "公司简介",
          key: "CompanyProfile",
        },
        {
          index: 1,
          text: "荣誉资质",
          key: "Honor",
        },
        {
          index: 2,
          text: "发展历程",
          key: "DevelopmentPath",
        },
        {
          index: 3,
          text: "企业文化",
          key: "CompanyCulture",
        },
      ],
      resBanners: [
        // {
        //   imageUrl:require('../assets/images/company/banner.png'),
        //   skipHref:''
        // }
      ],
    };
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    async getDataList() {
      let res = await this.$request.getImageAdvertisingList({
        advertisingPosition: "1",
      });
      if (res.code === 200) {
        this.resBanners = [];
        res.rows.map((item, index) => {
          item.imageUrl = this.$store.state.baseUrl + item.imageUrl;
        });
        this.resBanners = res.rows;
        this.$nextTick(() => {
          this.$refs.cBanner.reInitBanner();
        });
      }
    },
  },
  watch: {
    // 监听路由发生改变
    $route: {
      handler(newVal, oldval) {
        if (newVal != oldval && newVal.query.key) {
          let resList = this.pnavList.filter((item) => {
            // console.log(newVal.query.key);
            // console.log(item.key);
            return newVal.query.key === item.key;
          });
          this.componentTag = resList[0];
          this.$nextTick(() => {
            this.$refs.cBanner.reInitBanner();
          });
        }
      },
      immediate: true,
    },
  },
  components: {
    Banner,
    CompanyProfile,
    Honor,
    DevelopmentPath,
    CompanyCulture,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/common.scss";
.decoration1 {
  display: block;
  width: 2.34vw;
  height: 2.34vw;
  border-radius: 50%;
  border: 1.56vw solid $ThemeColor;
  position: absolute;
  top: -2.76vw;
  left: 0;
  z-index: 6;
}
.company {
  max-width: 100%;
  // overflow: hidden;
  .box_nav {
    width: 72.92vw;
    height: 7.92vw;
    margin: 0 auto;
    position: relative;
    .pnav {
      float: right;
      width: auto;
      height: 2.08vw;
      line-height: 2.08vw;
      padding: 3.13vw 0 0 0;
      cursor: pointer;

      position: relative;
      z-index: 11;
      .navItem {
        display: inline-block;
        width: 7.71vw;
        height: 2.08vw;
        border: 0.05vw solid #83bb26;
        font-size: 0.83vw;
        text-align: center;
        letter-spacing: 0.05vw;
        margin: 0 0 0 4.17vw;
        color: #333333;
        background-color: #ffffff;
        &.on {
          color: #ffffff;
          border: 0.05vw solid #83bb26;
          background-color: #83bb26;
        }
        .nuxtLink {
          display: inline-block;
          width: 100%;
        }
      }
    }
  }
  .companyLine {
    display: block;
    width: 100%;
    height: 0.05vw;
    background-color: #eeeeee;
  }
}
@media (min-width: 1920px) {
  .decoration1 {
    display: block;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    border: 30px solid $ThemeColor;
    position: absolute;
    top: -53px;
    left: 0;
    z-index: 6;
  }
  .company {
    max-width: 100%;
    // overflow: hidden;
    .box_nav {
      width: 1400px;
      height: 152px;
      margin: 0 auto;
      position: relative;
      .pnav {
        float: right;
        width: auto;
        height: 40px;
        line-height: 40px;
        padding: 60px 0 0 0;
        cursor: pointer;

        position: relative;
        z-index: 11;
        .navItem {
          display: inline-block;
          width: 148px;
          height: 40px;
          border: 1px solid #83bb26;
          font-size: 16px;
          text-align: center;
          letter-spacing: 1px;
          margin: 0 0 0 80px;
          color: #333333;
          background-color: #ffffff;
          &.on {
            color: #ffffff;
            border: 1px solid #83bb26;
            background-color: #83bb26;
          }
          .nuxtLink {
            display: inline-block;
            width: 100%;
          }
        }
      }
    }
    .companyLine {
      display: block;
      width: 100%;
      height: 1px;
      background-color: #eeeeee;
    }
  }
}
</style>
